import type { SVGProps } from 'react';
const SvgPlayForWork = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#play_for_work_svg__a)">
      <path
        fill="currentColor"
        d="M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2Zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6Z"
      />
    </g>
    <defs>
      <clipPath id="play_for_work_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlayForWork;
